import React, { useState } from "react";
import SideControl from "../../components/SideControl";
import styles from "./Projects.module.css";
import {
    FormControl,
    FormControlLabel,
    FormLabel,
    InputAdornment,
    InputLabel,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    TextField,
} from "@mui/material";
import { SearchOutlined } from "@mui/icons-material";
import ProjectCard from "../../components/ProjectCard";
import AddIcon from "@mui/icons-material/Add";
import ThemedModal from "../../components/ThemedModal";
import { useNavigate } from "react-router-dom";

const Projects = () => {
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    return (
        <>
            <div className={'sideControlContainer'}>
                <SideControl />
            </div>
            <div className={`projectsContainer flex-col-direction`}>
                <section className={styles.searchSection}>
                    <div>
                        <TextField
                            fullWidth
                            size="small"
                            label="Search Project"
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <SearchOutlined
                                            sx={{
                                                color: "#00CFFF",
                                            }}
                                        />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </div>
                    <div>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">
                                Sort By
                            </InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Sort By"
                                size="small"
                                // defaultValue="Last Modified"
                                value={1}
                            >
                                <MenuItem value={1}>Last Modified</MenuItem>
                                <MenuItem value={2}>First Modified</MenuItem>
                                <MenuItem value={3}>Name</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                </section>
                <section className={styles.industrySection}>
                    <div>Industry</div>
                    <div>
                        <FormControl>
                            <RadioGroup
                                row
                                sx={{ gap: 10 }}
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                defaultValue={1}
                            >
                                <FormControlLabel
                                    value="1"
                                    control={<Radio />}
                                    label="Mining"
                                />
                                <FormControlLabel
                                    value="2"
                                    control={<Radio />}
                                    label="Telecom"
                                />
                                <FormControlLabel
                                    value="3"
                                    control={<Radio />}
                                    label="Agriculture"
                                />
                                <FormControlLabel
                                    value="4"
                                    control={<Radio />}
                                    label="Survay & Mapping"
                                />
                                <FormControlLabel
                                    value="5"
                                    control={<Radio />}
                                    label="Other"
                                />
                            </RadioGroup>
                        </FormControl>
                    </div>
                </section>
                <section className={styles.projectSection}>
                    <div>Recent Projects</div>
                    <div>
                        {Array.from({ length: 4 }).map((el, i) => {
                            return <ProjectCard key={i} onClick={()=> navigate("/dashboard")} />;
                        })}
                        <div className={styles.cardComp} onClick={()=>setOpen(true)}>
                            <AddIcon
                                sx={{ color: "var(--secondary-2)" }}
                                fontSize="large"
                            />
                        </div>
                    </div>
                </section>
            </div>
            <ThemedModal open={open} setOpen={setOpen} />
        </>
    );
};

export default Projects;
